import { PayloadAction } from '@reduxjs/toolkit'
import { RoutesMap } from 'redux-first-router'

interface SyncRoutesMapPayload {
  dependencies: RoutesMap
  features: Record<string, boolean>
}
export const syncRoutesMapAction = (
  dependencies: RoutesMap,
  features: Record<string, boolean>,
): PayloadAction<SyncRoutesMapPayload> => ({
  payload: { dependencies, features },
  type: 'SYNC_ROUTE_MAP',
})

export const syncRoutesMapUpdateAction = (
  payload: RoutesMap,
): PayloadAction<RoutesMap> => ({
  payload,
  type: 'SYNC_ROUTE_MAP_UPDATE',
})
